<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { utils } from '@/helpers';

const PAGINAS_PUBLICAS = ['/login', '/activarCliente', '/recuperarPass'];

export default {
  name: 'App', 
  data(){
    return {
      style: {
        'height':window.innerHeight+'px',
        'background-color':'white'
      }
    }
  },
  mounted(){
    this.onResize();
    window.addEventListener('resize', this.onResize);
    window.addEventListener('storage', this.onCambioSesion);

    //aviso pendiente de una recarga por cambio de sesion en otra pestaña
    try {
      if (sessionStorage.getItem('sesion_cambiada')) {
        sessionStorage.removeItem('sesion_cambiada');
        utils.alerta({msg: 'La sesión cambió en otra pestaña (otro usuario o cliente). La página se recargó con la sesión actual.', status: 'warning'});
      }
    } catch (e) {
      //sin sessionStorage no se muestra el aviso
    }
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('storage', this.onCambioSesion);
  },
  methods:{
    //localStorage es compartido entre pestañas: si otra pestaña inicia sesion con otro usuario,
    //cambia de cliente o cierra sesion, esta pestaña no debe seguir operando con los datos que tiene cargados
    onCambioSesion(e){
      if (e.key !== 'user' && e.key !== null) return; //key null = localStorage.clear()
      if (PAGINAS_PUBLICAS.includes(window.location.pathname)) return;

      let antes = null;
      let despues = null;
      try {
        antes = JSON.parse(e.oldValue || 'null');
        despues = JSON.parse(localStorage.getItem('user') || 'null');
      } catch (err) {
        //valor invalido, se trata como sesion cerrada
      }

      if (!despues) {
        window.location.href = '/login';
        return;
      }

      if (!antes || antes.id_usuario != despues.id_usuario || antes.id_cliente != despues.id_cliente) {
        try {
          sessionStorage.setItem('sesion_cambiada', '1');
        } catch (err) {
          //sin sessionStorage solo se recarga
        }
        window.location.href = '/home';
      }
    },
    onResize () {
      this.style = {
        'height':window.innerHeight+'px',
        'background-color':'white'
      }
    }
  }
}
</script>

<style>
</style>

